import Box from "@mui/material/Box";

import { GroupTitleProps } from "./global";
import { EnhancedTableStatusCell } from "@vocollege/components";

const GroupTitle: React.FC<GroupTitleProps> = (props) => {
  const { item } = props;

  return (
    <Box component="span">
      {item?.title}
      {typeof item?.status !== "undefined" &&
        parseInt(`${item?.status}`) === 0 && (
          <Box sx={{ ml: 0.5 }}>
            <EnhancedTableStatusCell data={item?.status} />
          </Box>
        )}
    </Box>
  );
};

export default GroupTitle;
